import React, { useEffect, useState } from "react";
import { SubscriptionDetailsWrapper, SubscriptionPaymentWrapper } from "./SubscriptionDetails.style";
import { Link, useNavigate } from "react-router-dom";
import { IMAGES, URL_GLOBAL_LANDING_PAGE } from "Helpers";
import { Api } from "Helpers";
import LazyImage from "Components/Commons/LazyImage/LazyImage";

import Header from "Components/Header/Header";
import MobileHeader from "Components/Header/MobileHeader";
import Footer from "Components/Footer/Footer";
import PageHeading from "Components/PageHeading/PageHeading";

import CustomButton from "Components/Commons/CustomButton/CustomButton";


import { ReactComponent as TryAgain } from "../../../Assets/Images/Button/try_again.svg";


import { SubscriptionPaymentStatusPageContainer } from "./SubscriptionPaymentStatus.style";

function SubscriptionPaymentStatus() {
	const navigate = useNavigate();
	const getPaymentStatus = new URLSearchParams(window?.location?.search);
	const paymentStatus = JSON.parse(getPaymentStatus.get("isSuccess"));

	const [loading, setLoading] = useState(false);

	const handleLoginCMS = () => {
		window.location.href = `${process.env.REACT_APP_CMS_URL}login`;
	};

	const getSubscription = async () => {
		setLoading(true);
		const subscriptionData = localStorage.getItem("subscription");

		if (subscriptionData && JSON.parse(subscriptionData)) {
			const data = JSON.parse(subscriptionData);

			const response = await new Api().post("stripe/check-out/form", { data: data });

			if (response?.status === 200) {
				localStorage.setItem("subscription", JSON.stringify(data));
				if (response?.data) {
					window.location.href = response?.data;
				}
			}
		} else {
			localStorage.removeItem("subscription");
			navigate(URL_GLOBAL_LANDING_PAGE);
		}
		setLoading(false);
	};

	useEffect(() => {
		if (paymentStatus) {
			localStorage.removeItem("subscription");
			// setTimeout(() => {
			// 	handleLoginCMS();
			// }, 3000);
		}
	}, []); // eslint-disable-line

	return (
		<SubscriptionPaymentStatusPageContainer>
			<Header />
			<MobileHeader />
			<PageHeading
				title={
					<>
						Payment <span className="redfont"> Status</span>
					</>
				}
				breadcrumbs={[]}
			/>

			{/* <LazyImage compressedImage={IMAGES.LANDING_PAGE.TEACHER_BACKGROUND_COMPRESSED} image={IMAGES.LANDING_PAGE.TEACHER_BACKGROUND} wrapperProps={{ className: "background-image" }} /> */}
			{/* <div className="header-container">
				<div className="top-bar">
					<div className="subject-logo" onClick={() => navigate(URL_GLOBAL_LANDING_PAGE)}></div>
				</div>
			</div> */}
			<div className="main-container-payment-status">
				<div className="mygrid-container">

					<div className={`board-plans decrease-gird-gap`}>
						{/* <h3 className={`text-board selected disable`}>Payment Status</h3> */}
					</div>
					<div className="board payment_status_boxed">
						<SubscriptionPaymentWrapper>
							{paymentStatus ? (
								<>
									{/* <div className="payment-sticker-success"></div> */}
									<div className="checkmark-wrapper">
										<svg className="checkmark" viewBox="0 0 52 52">
											<circle className="checkmark-circle" cx="26" cy="26" r="25" />
											<path className="checkmark-check" d="M14 27l7 7 16-16" />
										</svg>
									</div>

									<h3>Payment Success!</h3>
									<p>Your payment has been completed successfully!</p>
									<div className="try-again-parent">
										<CustomButton onClick={handleLoginCMS} text="Redirect to portal login" />
									</div>
								</>
							) : (
								<>
									<div className="payment_status_boxed">


										<div className="checkmark-wrapper-fail">
											<svg className="checkmark-fail" viewBox="0 0 52 52">
												<circle className="checkmark-circle-fail" cx="26" cy="26" r="25" />
												<line className="checkmark-x" x1="16" y1="16" x2="36" y2="36" />
												<line className="checkmark-x" x1="36" y1="16" x2="16" y2="36" />
											</svg>
										</div>

										<h3>Payment Failed!</h3>
										<p>Your payment has failed!</p>
										<div className="try-again-parent">
											{/* <div className="font">Try Again</div>
											<div className="try-again"></div> */}
											<Link onClick={getSubscription} className={`customs_btn`}>
												Try Again
												<span>
													<svg
														xmlns="http://www.w3.org/2000/svg"
														width="20"
														height="20"
														viewBox="0 0 24 24"
														fill="none"
														stroke="#fff"
														strokeWidth="2"
														strokeLinecap="round"
														strokeLinejoin="round"
														className="try-again-icon"
													>
														<path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
													</svg>
												</span>
											</Link>


										</div>
									</div>
								</>
							)}
						</SubscriptionPaymentWrapper>
					</div>
				</div>
			</div>
			<Footer />
		</SubscriptionPaymentStatusPageContainer>
	);
}

export default SubscriptionPaymentStatus;
